import { Colors } from '../../../../utils/resources/colors';
import { Fonts } from '../../../../utils/resources/fonts';
import { PlayerComponentCSSStyle, PlayerComponentCSSStyleImpl } from '../playercss';


export interface PlayerWithSeekbarComponentCSSStyle extends PlayerComponentCSSStyle
{
    getPlayDivCSSStyle(): object;
    getStartTimePlayEndTimeDivCSSStyle(): object;
    getStartTimeCSSStyle(): object;
    getPlayIconCSSStyle(): object;
    getEndTimeCSSStyle(): object;
    getSeekbarCSSStyle(percent :string): object;
    getReplaceButtonCSSStyle(): object;
}

export class PlayerWithSeekbarComponentCSSStyleImpl extends PlayerComponentCSSStyleImpl implements PlayerWithSeekbarComponentCSSStyle
{
    getPlayDivCSSStyle(): object 
    {
        return {
            display: "flex",
            flexWrap: "wrap",
            width: "100%",
            alignContent: "flex-start"
            // display: "flex",
            // textAlign: "center",
            // alignItems: 'center', 
            // justifyContent: 'center', 
            // position: "absolute",
            // marginTop: "110px",
            // marginLeft: "90px",
            // marginRight: "90px",
            // cursor: "pointer",
            // width: "40px",
            // height: "40px"
        };
    }

    getStartTimePlayEndTimeDivCSSStyle(): object 
    {
        return {
            height: "24px",
            display: "flex",
            flexWrap: "wrap",
            width:"100%"
        };
    }

    getStartTimeCSSStyle(): object 
    {
        return {
            height: "20px",
            fontSize: this.getResources().getFont(Fonts.h5),
            fontWeight: 900,
            color: this.getResources().getColor(Colors.color_5),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            letterSpacing: 0,
        };
    }

    getPlayIconCSSStyle(): object 
    {
        return {
            cursor: "pointer",
            height: "24px",
            flex: 1
        };
    }

    getEndTimeCSSStyle(): object 
    {
        return {
            height: "20px",
            color: this.getResources().getColor(Colors.color_5),
            fontFamily: this.getResources().getFontFamily(),
            lineHeight: "20px",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h5),
            fontWeight: 900,
        };
    }

    getReplaceButtonCSSStyle(): object {
        return {
            // height: "31px",
            width:'25%',
            float : "right",
            marginRight : "5%"
        };
    }

    getSeekbarCSSStyle(percent : string): object 
    {
        return {
            height: "5px",
            width: "100%",
            marginTop : "12px",
            WebkitAppearance: "none",
            background: "linear-gradient(to right, #D7006D 0%, #D7006D "+ percent +"%, #fff "+ percent +"%, #fff 100%)",
            outline: "none",
            opacity: "0.7",
            webkitTransition: ".2s all ease-out",
            transition: "background 450ms ease-out",
            cursor : "pointer",
            border: " 2px solid #FFCB08",
            borderRadius: "1px",
            backgroundColor: "#D8D8D8"
        };
    } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/player/playerwithseekbar/playerwithseekbarcss.tsx